export function transformToBackendTranslationList(data: any) { // eslint-disable-line
  return {
    id: data.id,
    name: data.name,
    fields: data.fields
  }
}

export function transformFromBackendTranslationList(backendType: any) { // eslint-disable-line
  return {
    id: backendType.id,
    name: backendType.name,
    fields: backendType.fields
  }
}
